import type { WorkshopContribution } from "@/types/workshop";

export function workshopAnswerOptions(
  response?: Pick<WorkshopContribution, "optionIndex" | "optionIndices">,
): number[] {
  if (!response) return [];
  if (response.optionIndex !== null) return [response.optionIndex];
  return response.optionIndices ?? [];
}
